export default __webpack_public_path__ + "static/media/safsa-img.a3bb0dc8.jpg";